import { defineStore } from 'pinia';
import axios from 'axios';

export const useGradeStore = defineStore('grade', {
    state: () => ({
        currentGrade: null,       // full academic year object
        activeGrades: [],
        allGrades: [],
        loading: false,
    }),

    getters: {
        currentGradeId: (state) => state.currentGrade?.id ?? null,
        currentGradeName: (state) => state.currentGrade?.name ?? '',
        currentGradeSlug: (state) => state.currentGrade?.slug ?? '',
        currentLegacyLevel: (state) => state.currentGrade?.education_level_legacy ?? null,

        gradesByStage: (state) => {
            const grouped = { primary: [], prep: [], secondary: [] };
            for (const g of state.allGrades) {
                grouped[g.stage]?.push(g);
            }
            return grouped;
        },

        activeGradesByStage: (state) => {
            const grouped = { primary: [], prep: [], secondary: [] };
            for (const g of state.activeGrades) {
                grouped[g.stage]?.push(g);
            }
            return grouped;
        },
    },

    actions: {
        setCurrentGrade(grade) {
            this.currentGrade = grade;
            if (grade) {
                localStorage.setItem('currentGradeId', grade.id);
            } else {
                localStorage.removeItem('currentGradeId');
            }
        },

        async fetchActiveGrades() {
            this.loading = true;
            try {
                const { data } = await axios.get('/academic-years/active');
                this.activeGrades = data.data;
            } finally {
                this.loading = false;
            }
        },

        async fetchAllGrades() {
            this.loading = true;
            try {
                const { data } = await axios.get('/academic-years');
                this.allGrades = data.data;
            } finally {
                this.loading = false;
            }
        },

        async toggleGrade(id) {
            const { data } = await axios.patch(`/academic-years/${id}/toggle`);
            const idx = this.allGrades.findIndex(g => g.id === id);
            if (idx !== -1) this.allGrades[idx] = data.data;
            // refresh active list
            await this.fetchActiveGrades();
            return data.data;
        },

        async toggleReservation(id) {
            const { data } = await axios.patch(`/academic-years/${id}/toggle-reservation`);
            const idx = this.allGrades.findIndex(g => g.id === id);
            if (idx !== -1) this.allGrades[idx] = data.data;
            // refresh active list
            await this.fetchActiveGrades();
            return data.data;
        },

        restoreCurrentGrade() {
            const savedId = localStorage.getItem('currentGradeId');
            if (savedId && this.activeGrades.length) {
                const found = this.activeGrades.find(g => g.id === parseInt(savedId));
                if (found) this.currentGrade = found;
            }
        },
    },
});
